<template>
    <transition appear name="fade-transition">
        <div :class="classList">
            <v-text-field
                ref="input"
                v-model="amount"
                v-mask="maskValue"
                v-test-id
                :name="name || uuid"
                outlined
                dense
                :rules="validators"
                :label="hideLabel ? null : label"
                background-color="background"
                color="primaryText"
                :hide-details="hideDetails || (!form && _.isEmpty(validators))"
                class="text-right"
                :reverse="reverse"
                :placeholder="hidePlaceholder ? null : 'e.g. 12,345.67'"
                :disabled="disabled"
                :loading="loading"
                :autocomplete="autocomplete ? 'on' : 'off'"
                :error="error"
                :error-messages="errorMessages"
                :readonly="readonly"
                :clearable="!required && clearable"
                @focus="
                    focused = true;
                    $emit('focus', inputValue);
                "
                @blur="
                    focused = false;
                    $emit('blur', inputValue);
                "
                @keyup="$emit('keyup', inputValue)"
                @keydown="$emit('keydown', inputValue)"
                @click="$emit('click', inputValue)"
            >
                <template #prepend>
                    <slot name="prepend" />
                </template>
                <template #prepend-inner>
                    <slot name="prepend-inner" />
                </template>
                <template #append>
                    <slot name="append" />
                    <app-tooltip v-if="info || findSlot('info')" :value="info">
                        <v-icon dense small color="info" style="margin-bottom: 0.1rem">{{
                            getIcon('info', 'fad')
                        }}</v-icon>
                        <template v-if="findSlot('info')" #display>
                            <slot name="info" />
                        </template>
                    </app-tooltip>
                </template>
                <template #append-outer>
                    <slot name="append-outer" />
                </template>
            </v-text-field>
        </div>
    </transition>
</template>

<script>
import Edit from './Edit';

export default {
    name: 'EditNumber',
    extends: Edit,
    props: {
        reverse: {
            type: Boolean,
            default: false
        },
        autocomplete: {
            type: Boolean,
            default: false
        },
        allowMinus: {
            type: Boolean,
            default: false
        }
    },
    data: () => ({
        focused: false
    }),
    computed: {
        maskValue() {
            if (this.mask) {
                return this._.isFunction(this.mask) ? this.mask() : this.mask;
            }

            return this.getMask('number', {
                digits: this.getOption('decimals', 8),
                allowMinus: this.allowMinus || this.getOption('allowMinus', false),
                rightAlign: !this.reverse,
                prefix: this.prefixValue,
                suffix: this.suffixValue
            });
        },
        amount: {
            get() {
                return this.toDecimal(this.inputValue, {
                    precision: this.getOption('decimals', 8),
                    callback: money => money.value
                });
            },
            set(v) {
                this.inputValue = this.toDecimal(v, {
                    precision: this.getOption('decimals', 8),
                    callback: money => money.value
                });
            }
        }
    }
};
</script>

<style lang="scss">
.edit__number {
    min-width: 7rem;
}
</style>
